import {
    IBoletosRequest,
    IEnviarBoletoPorEmailSienge,
    IGerarBoletoIntegral,
    IGerarBoletosResponse,
    IGerarLinkBoletoSienge,
    IGerarLinkBoletoSiengeResponse,
    IGestaoBoletoFiltro,
    IGestaoBoletoResponse,
} from "../../../Interfaces/Cobranca/Boleto/BoletoInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

type TBoletosGestaoResponse = IGestaoBoletoResponse | Blob;

export async function ListarBoletosGestaoService(
    requestBody: IGestaoBoletoFiltro
) {
    const response = await Axios.post<TBoletosGestaoResponse>(
        `/cobranca/boleto/listarboletosgestao`,
        requestBody,
        { responseType: requestBody.NR_PAGINA > 0 ? "json" : "blob" }
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function GerarBoletoService(requestBody: IBoletosRequest) {
    const response = await Axios.post<IGerarBoletosResponse>(
        `/cobranca/boleto/gerarboleto `,
        requestBody
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}

export async function AlterarDataVencimentoBoletosService(
    SeuNum_Rea: number,
    Banco_Rea: number,
    Empresa_rea: number,
    DtVencimentoNovo: string,
    DtCalculo: string
) {
    return Service(
        Axios.post<string>(
            `/cobranca/boleto/alterardatavencimentoboletos?SeuNum_Rea=${SeuNum_Rea}&Banco_Rea=${Banco_Rea}&Empresa_rea=${Empresa_rea}&DtVencimentoNovo=${DtVencimentoNovo}&DtCalculo=${DtCalculo}`
        )
    );
}

export async function GerarBoletoViaContaService(
    requestBody: IBoletosRequest,
    ID_CONTA: number,
    idTipoCaso: number
) {
    return Service(
        Axios.post<IGerarBoletosResponse>(
            `/cobranca/boleto/gerarboletoviaconta?ID_CONTA=${ID_CONTA}&idTipoCaso=${idTipoCaso}`,
            requestBody
        )
    );
}

export async function EnviarBoletoPorEmailSiengeService(
    requestBody: IEnviarBoletoPorEmailSienge
) {
    return Service(
        Axios.post(
            `/cobranca/boleto/enviaremailsegundaviaboletosienge`,
            requestBody
        )
    );
}

export async function GerarLinkBoletoSegundaViaSiengeService(
    requestBody: IGerarLinkBoletoSienge
) {
    return Service(
        Axios.post<IGerarLinkBoletoSiengeResponse>(
            `/cobranca/boleto/gerarlinkboletosegundaviasienge`,
            requestBody
        )
    );
}

export async function GerarBoletoIntegralService(
    requestBody: IGerarBoletoIntegral
) {
    return Service(
        Axios.post(
            `/cobranca/boleto/gerarboletovariasparcelastotvs`,
            requestBody
        )
    );
}

export async function BaixarBoletoViaTokenService(base64Token: string, cpfCliente: string) {
    return Service(Axios.post(`/cobranca/boleto/BaixarBoletoViaToken?base64Token=${base64Token}&cpfCliente=${cpfCliente}`));
}

